const baseUrl = 'https://xttd.lyuuch.com/api';
// const baseUrl = 'http://localhost:8121';

export default {
  baseUrl,
}